import React from "react";
import "./PlayerItem.css";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";

interface PlayerItemProps {
  name: string;
  lastMatch: string;
  rating: string;
  isSelected: boolean;
  onSelect: () => void;
  imageUrl?: string; // Add optional image URL
  isExclude?: boolean;
}

export const PlayerItem: React.FC<PlayerItemProps> = ({
  name,
  lastMatch,
  rating,
  isSelected,
  onSelect,
  imageUrl,
  isExclude,
}) => {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const getOpacity = () => {
    if (isExclude && !isSelected) {
      return 0.5;
    }
    return 1;
  };

  return (
    <div
      className="player-item"
      onClick={onSelect}
      style={{ opacity: getOpacity() }}>
      <div className="player-info">
        <div className="player-avatar">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={name}
              className="player-image"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.parentElement!.dataset.initials =
                  getInitials(name);
              }}
            />
          ) : (
            getInitials(name)
          )}
        </div>
        <span className="player-rating">{rating}</span>
        <div className="player-details">
          <TCText value={name} className="player-name" />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 5,
            }}>
            <TCText value="Last match" className="player-last-match" />
            <div
              style={{
                width: 1,
                height: 15,
                backgroundColor: Colors.lightGreyBackground,
              }}
            />
            <TCText
              style={{ fontWeight: 600, fontSize: 12, color: Colors.darkBrown }}
              value={lastMatch}
            />
          </div>
        </div>
      </div>
      <div className={`select-indicator ${isSelected ? "selected" : ""}`}>
        {isSelected && <span>✓</span>}
      </div>
    </div>
  );
};
